export default __webpack_public_path__ + "static/river-level-7072babfdd759ebde92d4db435dd190b.png";